/* © NXAPP Limited */
import { useState } from 'react'
import { useAuthContext } from '@/context/AuthContext'
import { supabase } from '@/lib/supabase'
import { User } from 'lucide-react'

export default function ProfilePage() {
  const { user } = useAuthContext()
  const [name, setName] = useState('')
  const [saved, setSaved] = useState(false)
  const [newPw, setNewPw] = useState('')
  const [pwMsg, setPwMsg] = useState('')

  async function saveName(e: React.FormEvent) {
    e.preventDefault()
    await supabase.from('profiles').upsert({ id: user!.id, email: user!.email!, name })
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  async function changePassword(e: React.FormEvent) {
    e.preventDefault()
    const { error } = await supabase.auth.updateUser({ password: newPw })
    setPwMsg(error ? error.message : 'Password updated.')
    setNewPw('')
  }

  return (
    <div className="space-y-6 max-w-lg">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Profile</h1>
        <p className="text-sm text-gray-500 mt-1">Your admin account settings</p>
      </div>

      <div className="card p-5 flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-brand-100 flex items-center justify-center">
          <User className="w-6 h-6 text-brand-600" />
        </div>
        <div>
          <p className="font-semibold text-gray-900">{user?.email}</p>
          <p className="text-xs text-gray-400">Admin</p>
        </div>
      </div>

      <form onSubmit={saveName} className="card p-5 space-y-4">
        <h2 className="font-semibold text-gray-900">Display name</h2>
        <div>
          <label className="label">Name</label>
          <input className="input" value={name} onChange={e => setName(e.target.value)} placeholder="Your name" />
        </div>
        <button type="submit" className="btn-primary">{saved ? 'Saved!' : 'Save name'}</button>
      </form>

      <form onSubmit={changePassword} className="card p-5 space-y-4">
        <h2 className="font-semibold text-gray-900">Change password</h2>
        <div>
          <label className="label">New password</label>
          <input className="input" type="password" value={newPw} onChange={e => setNewPw(e.target.value)} placeholder="8+ characters" />
        </div>
        {pwMsg && <p className="text-sm text-gray-600">{pwMsg}</p>}
        <button type="submit" className="btn-primary" disabled={newPw.length < 8}>Update password</button>
      </form>
    </div>
  )
}
